import React from 'react'
import { Button as MuiButton, styled } from '@mui/material'
import { Loader } from 'packages/eid-ui'
import EditButton from './EditButton'
import DeleteButton from './DeleteButton'
import ViewProfileButton from './ViewProfileButton'
import NewDelegationButton from './NewDelegationButton'
import RoundedButton from './RoundedButton'
import AddAllButton from './AddAllButton'
import RemoveAllButton from './RemoveAllButton'
import AddButton from './AddButton'
import RemoveButton from './RemoveButton'
import SortButton from './SortingButton'

const styles = {
    small: {
        padding: '3.25px 20px',
        minHeight: '35px',
    },
    medium: {
        padding: '5.25px 15px',
        minHeight: '39px',
    },
    large: {
        padding: '9.25px 30px',
        minHeight: '47px',
    },
}

const StyledButton = styled(MuiButton)((props) => ({
    textTransform: 'capitalize',
    fontSize: '20px',
    border: '1px solid transparent',
    borderRadius: '5px',
    ...props.variantStyles,
    ...props.style,
    '& .MuiButton-startIcon': {
        marginRight: props.size === 'large' ? '14px' : '10px',
    },

    '&.Mui-disabled': {
        ...props.disabledStyles,
    },
}))

const Button = ({
    size,
    children,
    style,
    disabledStyles,
    loading,
    loaderColor,
    startIcon,
    endIcon,
    onClick,
    ...rest
}) => {
    const variantStyles = styles[size]

    return (
        <StyledButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            size={size}
            style={style}
            variantStyles={variantStyles}
            disabledStyles={disabledStyles}
            //classes={classes}
            onClick={!loading ? onClick : undefined}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    style={{ background: 'transparent' }}
                    color={loaderColor ? loaderColor : '#ffffff'}
                    height="1inh"
                />
            )}
        </StyledButton>
    )
}

Button.Edit = EditButton
Button.Delete = DeleteButton
Button.ViewProfile = ViewProfileButton
Button.NewDelegation = NewDelegationButton
Button.Rounded = RoundedButton
Button.Add = AddButton
Button.AddAll = AddAllButton
Button.RemoveAll = RemoveAllButton
Button.Remove = RemoveButton
Button.Sort = SortButton

export default Button
